/**
 * 维修无忧列表 -- 状态
 */
export default function repairStatus(val) {
    let str = '';
    switch (val) {
    case 'TO_APPLY':
        str = '待申请';
        break;
    case 'BIZ_TO_AUDIT':
        str = '待审核';
        break;
    case 'INSURANCE_TO_AUDIT':
        str = '待审核';
        break;
    // case 'REJECT':
    //     str = '已驳回';
    //     break;
    case 'TO_SETTLE':
        str = '待结算';
        break;
    case 'TO_LXT_CONFIRM':
        str = '待结算';
        break;
    case 'SETTLED':
        str = '已结算';
        break;
    default:
        break;
    }
    return str;
}
